import React, { useState } from "react";

import { useDispatch } from "react-redux";
import classnames from "classnames";

import makeStyles from "@material-ui/core/styles/makeStyles";
import Paper from "@material-ui/core/Paper";

import { PageHeader, SimpleForm, SelectInput, showNotification, required } from "jazasoft";

// local
import ExcelErrorDialog from "../../../components/ExcelErrorDialog";
import MyFileInput from "../../../components/MyFileInput";

import { ChecklistType } from "../../../utils/types";
import useMutation from "../../../hooks/useMutation";

const useStyles = makeStyles(theme => ({
  root: {},
  container: {
    margin: theme.spacing(3),
    padding: "1.5em"
  },
  card: {
    padding: "0",
    boxShadow: theme.shadows[1],
    backgroundColor: "white"
  },
  marginVertical: {
    margin: "1em 0"
  },
  displayCenter: {
    display: "flex",
    justifyContent: "center"
  }
}));

const CuChecklistCreate = props => {
  const [errors, setErrors] = useState(null);

  const [mutate] = useMutation();
  const dispatch = useDispatch();

  const onSubmit = values => {
    const { cuChecklist, techSheets, ...params } = values;
    var data = new FormData();
    data.append("cuChecklist", cuChecklist.rawFile);
    if (!!techSheets?.length) {
      for (let i = 0; i < techSheets.length; i++) {
        data.append("techSheets", techSheets[i]?.rawFile);
      }
    }
    const options = {
      url: `cuChecklists`,
      method: "post",
      data,
      params,
      headers: { "Content-Type": "multipart/form-data" }
    };
    mutate(options, {
      onSuccess: () => {
        dispatch(showNotification("CU Checklist uploaded successfully"));
        props.history.push("/estimation/cuChecklists");
      },
      onFailure: err => {
        if (err.status === 400 && err.errors && Array.isArray(err.errors)) {
          setErrors(err.errors);
        } else {
          dispatch(showNotification(err.message, { type: "danger" }));
        }
      }
    });
  };

  const classes = useStyles();
  return (
    <div className={classnames(classes.root)}>
      <PageHeader title="Cu Checklist Upload" />

      <ExcelErrorDialog open={errors !== null} errors={errors} onClose={() => setErrors(null)} />

      <Paper className={classes.container} square>
        <SimpleForm onSubmit={onSubmit}>
          <SelectInput
            source="checklistType"
            validate={[required()]}
            choices={Object.keys(ChecklistType).map(key => ({ id: ChecklistType[key], name: ChecklistType[key] }))}
            xs={12}
            sm={6}
          />
          <MyFileInput
            source="cuChecklist"
            label="Cu Checklist"
//             accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            accept={{
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx"],
              "application/vnd.ms-excel": [".xls"]
            }}
            xs={12}
            fullWidth
            validate={required()}
          />
          <MyFileInput source="techSheets" multiple label="Techsheets" xs={12} fullWidth />
        </SimpleForm>
      </Paper>
    </div>
  );
};

export default CuChecklistCreate;
